import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../../components/UI/Layout/Layout';
import MotorVoltageComponent from '../../../components/MotorDataComponents/MotorVoltageComponent/MotorVoltageComponent';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class MotorDataVoltagePage extends Component {
  goBackHandler = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;
    return (
      <Layout
        clicked={this.goBackHandler}
        title={LocalizedStrings[language].motorData}
        country={country}
        language={language}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
      >
        <MotorVoltageComponent country={country} language={language} />
      </Layout>
    );
  }
}

MotorDataVoltagePage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(MotorDataVoltagePage);
